export default "__VITE_ASSET__B_eZ1yj2__"